import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './services/axiosConfig'; // initialize interceptors
import {
    BrowserRouter as Router, Routes, //replaces "Switch" used till v5
    Route,
} from 'react-router-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import InvalidURL from './pages/shared/InvalidURL';
import PageTitle from './components/PageTitle';
import SignIn from './pages/Authentication/SignIn';
import Profile from './pages/Profile';
import Forbidden from './pages/shared/Forbidden';
import Registrarse from './pages/Authentication/Registrarse';
import ValidarCuenta from './pages/Authentication/ValidarCuenta';
import VerificarEmail from './pages/Authentication/VerificarEmail';
import SignUp from './pages/Authentication/SignUp';
import VerifiedAccount from './pages/Authentication/VerifiedAccount';
import SignupImagen from './pages/Authentication/SignupImagen';
import SignupExito from './pages/Authentication/SignupExito';
import ColegiosDepartamentales from './pages/ColegiosDepartamentales';
import RecuperarContrasena from './pages/RecuperarContrasena';
import Beneficios from './pages/Beneficios';
import Home from './pages/Home';
import Movimientos from './pages/Pagos/Movimientos';
import Pagar from './pages/Pagos/Pagar';
import Boleta from './pages/Pagos/Boleta';
import Transferencia from './pages/Pagos/Transferencia';
import Contacto from './pages/Contacto';
import Creditos from './pages/Creditos/Creditos';
import Simular from './pages/Creditos/Simular';
import DetalleCredito from './pages/Creditos/DetalleCredito';
import ListaCuotas from './pages/Creditos/ListaCuotas';
import ResultadoSimular from './pages/Creditos/ResultadoSimular';
import CargaDocumentos from './pages/Creditos/CargaDocumentos';
import ResultadoCrear from './pages/Creditos/ResultadoCrear';
import Supervivencia from './pages/Supervivencia/Supervivencia';
import VerificarSupervivenciaAWS from './pages/Supervivencia/VerificarSupervivenciaAWS';
import ReciboDeHaberes from './pages/Recibos/ReciboDeHaberes';
import DetalleRecibo from './pages/Recibos/DetalleRecibo';
import Credencial from './pages/Credencial';
import Notificaciones from './pages/Notificaciones/Notificaciones';
import NotificacionDetalle from './pages/Notificaciones/NotificacionDetalle';
import CallbackPagoBoletaExito from './pages/Pagos/CallbackPagoBoletaExito';
import CallbackPagoBoletaFalla from './pages/Pagos/CallbackPagoBoletaFalla';
import CallbackPagoPlanExito from './pages/Pagos/CallbackPagoPlanExito';
import CallbackPagoPlanFalla from './pages/Pagos/CallbackPagoPlanFalla';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    /*    <Router basename={baseUrl ? baseUrl : ''}>*/
    <Router basename='/'>
        {/* <Header />*/}
        <Routes>
            <Route
                index
                path="/"
                element={
                    <>
                        <PageTitle title="Inicio" />
                        <Home />
                    </>
                }
            />
            <Route
                path="/profile"
                element={
                    <>
                        <PageTitle title="Profile" />
                        <Profile />
                    </>
                }
            />

            {/* AUTENTICACION Y REGISTRACION */}
            <Route
                path="/auth/signin"
                element={
                    <>
                        <PageTitle title="Inicio de Sessión" />
                        <SignIn />
                    </>
                }
            />
           
            <Route
                path="/registrarse"
                element={
                    <>
                        <PageTitle title="Registrarse" />
                        <Registrarse />
                    </>
                }
            />
            <Route
                path="/validarCuenta"
                element={
                    <>
                        <PageTitle title="ValidarCuenta" />
                        <ValidarCuenta />
                    </>
                }
            />
            <Route
                path="/verificarEmail"
                element={
                    <>
                        <PageTitle title="VerificarEmail" />
                        <VerificarEmail />
                    </>
                }
            />
            <Route
                path="/verifiedAccount"
                element={
                    <>
                        <PageTitle title="VerifiedAccount" />
                        <VerifiedAccount />
                    </>
                }
            />
            <Route
                path="/signupImagen"
                element={
                    <>
                        <PageTitle title="SignupImagen" />
                        <SignupImagen />
                    </>
                }
            />
            <Route
                path="/signupExito"
                element={
                    <>
                        <PageTitle title="SignupExito" />
                        <SignupExito />
                    </>
                }
            />
            <Route
                path="/recuperarContrasena"
                element={
                    <>
                        <PageTitle title="Recuperar Contraseña" />
                        <RecuperarContrasena />
                    </>
                }
            />

            {/* PAGOS */}
            <Route
                path="/pagos/movimientos"
                element={
                    <>
                        <PageTitle title="Mis Movimientos" />
                        <Movimientos />
                    </>
                }
            />
            <Route
                path="/pagos/pagar"
                element={
                    <>
                        <PageTitle title="Realizar Pago" />
                        <Pagar />
                    </>
                }
            />
            <Route
                path="/pagos/boleta"
                element={
                    <>
                        <PageTitle title="Pagar Boleta" />
                        <Boleta />
                    </>
                }
            />
            <Route
                path="/pagos/transferencia"
                element={
                    <>
                        <PageTitle title="Informar Transferencia" />
                        <Transferencia />
                    </>
                }
            />

            <Route
                path="/pagos/callbackPagoBoletaExito"
                element={
                    <>
                        <PageTitle title="Pago exitoso" />
                        <CallbackPagoBoletaExito />
                    </>
                }
            />
            <Route
                path="/pagos/callbackPagoBoletaFalla"
                element={
                    <>
                        <PageTitle title="Pago fallido" />
                        <CallbackPagoBoletaFalla />
                    </>
                }
            />
            <Route
                path="/pagos/callbackPagoPlanExito"
                element={
                    <>
                        <PageTitle title="Pago exitoso" />
                        <CallbackPagoPlanExito />
                    </>
                }
            />
            <Route
                path="/pagos/callbackPagoPlanFalla"
                element={
                    <>
                        <PageTitle title="Pago fallido" />
                        <CallbackPagoPlanFalla />
                    </>
                }
            />
            {/* COLEGIOS */}
            <Route
                path="/colegiosDepartamentales"
                element={
                    <>
                        <PageTitle title="ColegiosDepartamentales" />
                        <ColegiosDepartamentales />
                    </>
                }
            />

            {/* BENEFICIOS */}
            <Route
                path="/beneficios"
                element={
                    <>
                        <PageTitle title="Beneficios" />
                        <Beneficios />
                    </>
                }
            />

            {/* CREDITOS / PRESTAMOS */}
            <Route
                path="/prestamos"
                element={
                    <>
                        <PageTitle title="Préstamos" />
                        <Creditos />
                    </>
                }
            />
            <Route
                path="/prestamos/simular"
                element={
                    <>
                        <PageTitle title="Simular un Préstamo" />
                        <Simular />
                    </>
                }
            />
            <Route
                path="/prestamos/detalle-credito/:id"
                element={
                    <>
                        <PageTitle title="Detalle del Préstamo" />
                        <DetalleCredito />
                    </>
                }
            />
            <Route
                path="/prestamos/lista-cuotas/:id"
                element={
                    <>
                        <PageTitle title="Listado de Cuotas" />
                        <ListaCuotas />
                    </>
                }
            />
            <Route
                path="/prestamos/resultado-simular"
                element={
                    <>
                        <PageTitle title="Resultado de la Simulación" />
                        <ResultadoSimular />
                    </>
                }
            />
            <Route
                path="/prestamos/resultado-crear"
                element={
                    <>
                        <PageTitle title="Resultado de la Solicitud" />
                        <ResultadoCrear />
                    </>
                }
            />
            <Route
                path="/prestamos/carga-documentos"
                element={
                    <>
                        <PageTitle title="Carga de Documentos" />
                        <CargaDocumentos />
                    </>
                }
            />

            {/* SUPERVIVENCIA */}
            <Route
                path="/supervivencia"
                element={
                    <>
                        <PageTitle title="Trámite de Supervivencia" />
                        <Supervivencia />
                    </>
                }
            />
            <Route
                path="/supervivencia/verificarSupervivenciaAWS"
                element={
                    <>
                        <PageTitle title="Verificar identidad" />
                        <VerificarSupervivenciaAWS />
                    </>
                }
            />

            {/* RECIBOS */}
            <Route
                path="/recibos"
                element={
                    <>
                        <PageTitle title="Recibos de Haberes" />
                        <ReciboDeHaberes />
                    </>
                }
            />
            <Route
                path="/recibos/detalle"
                element={
                    <>
                        <PageTitle title="Recibo de Haberes" />
                        <DetalleRecibo />
                    </>
                }
            />

            {/* NOTIFICACIONES */}
            <Route
                path="/notificaciones"
                element={
                    <>
                        <PageTitle title="Notificaciones" />
                        <Notificaciones />
                    </>
                }
            />
            <Route
                path="/notificaciones/detalle"
                element={
                    <>
                        <PageTitle title="Detalle de Notificación" />
                        <NotificacionDetalle />
                    </>
                }
            />

            {/* OTROS */} 
            <Route
                path="/credencial"
                element={
                    <>
                        <PageTitle title="Credencial Digital" />
                        <Credencial />
                    </>
                }
            />
            <Route
                path="/contacto"
                element={
                    <>
                        <PageTitle title="Contacto" />
                        <Contacto />
                    </>
                }
            />

            <Route
                path="/forbidden"
                element={<Forbidden />}
            />
            <Route path="*" element={<InvalidURL />} />

        </Routes>
    </Router>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
